import React from 'react'

const DomesticTransfersPage = () => {
  return (
    <div>DomesticTransfersPage</div>
  )
}

export default DomesticTransfersPage;